/**
 * @description
 * Given a primitive data type (i.e. string, number, bigint, boolean, undefined, symbol, and null)
 * ensure it is truthy (not undefined, null or empty strings.
 * */
export const isTruthy = (value: unknown): boolean => {
  if (value === undefined || value === null) return false;

  if (typeof value === 'number') return true;

  if (typeof value === 'string') return value !== '';

  /** @todo add support for other primitive types */

  return true;
};
